export default "__VITE_ASSET__5d7f8b9e__"